import { useState, useEffect } from "react";
import Axios from "axios";
import sha256 from "crypto-js/sha256";
import { ethers } from "ethers";
import { toast } from "react-toastify";

import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

import { SettingsView } from "../../../rtk/features/setting/SettingView";
import "./settingsDlg.css";

export default function SettingsDlg(props) {
  const handleClose = () => {
    props.setOpen(false);
  };

  const handleCloseAddWallet = () => {
    if (!props.userAuthWallet) {
      toast.error("First Connect Wallet!");
      return;
    }

    if (!inputs.email) {
      toast.error("Please enter valid email!");
      return;
    }

    const urlSfx = "/settings/add";
    Axios.post(process.env.REACT_APP_CRUD_SRV + urlSfx, {
      ...inputs,
      auth: props.userAuthWallet,
      cs: sha256(
        urlSfx +
          inputs.email +
          props.userAuthWallet +
          process.env.REACT_APP_SECRET
      ).toString(),
    }).then((r) => {
      if (r.data?.status == 200) {
        toast.success("Settings has been changed!");
      } else {
        const errorMsg =
          "Settings change error. " + process.env.REACT_APP_STR_TRY_AGAIN;
        // console.log(errorMsg);
        toast.error(errorMsg, {
          autoClose: 7000,
        });
      }
    });

    props.setOpen(false);
  };

  // const [walletAddress, setWalletAddress] = useState("");
  // const [walletName, setWalletName] = useState("");

  // function handleWalletAddressChange(evt) {
  //   setWalletAddress(evt.target.value);
  // }
  // function handleWalletNameChange(evt) {
  //   setWalletName(evt.target.value);
  // }

  const [inputs, setInputs] = useState({
    email: "",
    cbAlerts: true,
    cbFeatures: true,
    cbWalletAbbr: props.settingsWalletAbbr,
  });

  function inputChange(evt, onClickData = false) {
    let name, val;
    if (onClickData) {
      name = onClickData.name;
      val = onClickData.value;
    } else {
      name = evt.target.name;
      val = evt.target.value;
    }

    setInputs((prevInputs) => {
      return {
        ...prevInputs,
        [name]: val,
      };
    });
  }

  useEffect(() => {
    const getData = () => {
      const urlSfx = "/settings";
      const url =
        process.env.REACT_APP_CRUD_SRV +
        urlSfx +
        "?auth=" +
        props.userAuthWallet +
        "&cs=" +
        sha256(
          urlSfx + props.userAuthWallet + process.env.REACT_APP_SECRET
        ).toString();
      // console.log("CLG_URLS", process.env.REACT_APP_CLG_AXIOS_URLS);
      if (process.env.REACT_APP_CLG_AXIOS_URLS == 1) console.log(url);
      Axios.get(url).then((r) => {
        if (r.data?.status == 200) {
          // console.log("Settings are received successfully!", r.data);
          setInputs((prevInputs) => {
            return {
              ...prevInputs,
              ...r.data.response,
            };
          });
        } else {
          const errorMsg =
            "Error receiving settings. " + process.env.REACT_APP_STR_TRY_AGAIN;
          // console.log(errorMsg);
          toast.error(errorMsg, {
            autoClose: 7000,
          });
        }
      });
    };

    if (props.userAuthWallet) getData();
  }, [props.userAuthWallet]);

  function cbChange(evt) {
    // const { target } = e;
    // const value = target.type === 'checkbox' ? target.checked : target.value;
    // const { name } = target;

    // setForm( f => ({ ...f, [name]: value }));

    setInputs((prevInputs) => {
      return {
        ...prevInputs,
        [evt.target.name]: evt.target.checked,
      };
    });
  }

  // useEffect(() => {
  //   console.log("inputs =", inputs);
  // }, [inputs]);

  // tabs
  const [value, setValue] = useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="settingsDlg">
      <Dialog open={props.open} onClose={handleClose}>
        <DialogTitle>Settings</DialogTitle>
        <DialogContent>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList onChange={handleChange} aria-label="settings tabs">
                <Tab label="Emails" value="1" />
                <Tab label="Wallets" value="2" />
              </TabList>
            </Box>
            <TabPanel value="1" className="settingsTabPanel">
              <TextField
                autoFocus
                margin="dense"
                id="name"
                label="Email Address"
                type="email"
                fullWidth
                variant="standard"
                name="email"
                value={inputs.email}
                onChange={inputChange}
                // placeholder="Your Email"
              />
              <DialogContentText className="emailP">
                Email is used for correspondence with support.
              </DialogContentText>

              <div>
                <h2 style={{ margin: "20px 0 10px" }}>Emails to send</h2>
                <input
                  type="checkbox"
                  name="cbAlerts"
                  checked={inputs.cbAlerts}
                  onChange={cbChange}
                />{" "}
                Triggered alerts you've created
                <br />
                <input
                  type="checkbox"
                  name="cbFeatures"
                  checked={inputs.cbFeatures}
                  onChange={cbChange}
                />{" "}
                New DefiWatch features
              </div>
            </TabPanel>
            <TabPanel value="2" className="settingsTabPanel">
              <SettingsView />
            </TabPanel>
          </TabContext>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleCloseAddWallet}>Save Settings</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
